import { Component, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { HelperService } from '../../util/helper/helper.service';
import { HttpService } from '../../services/http/http.service';
import * as moment from 'moment';
import { FADE_IN } from '../../util/animations/animation';
@Component({
  selector: 'app-chat-bubble',
  templateUrl: './chat-bubble.component.html',
  styleUrls: ['./chat-bubble.component.scss'],
  animations: [FADE_IN]
})
export class ChatBubbleComponent {
  @Input() patientId;
  @Input() patientDetails: any = {};
  @Input() templates = [];
  @Output() private latestMessage = new EventEmitter();

  communicationListener;
  communicationMessages = [];
  fakeCommunicationMessages = [1, 2, 3, 4];
  practitioners = [];
  patients = [];
  isPractitionerData = false;
  isPatientData = false;
  isInitialAPICall = false;
  icons = {
    EMAIL: {
      icon: 'assets/images/patient-engagement/unsecure-email.png',// 'mail_outline',
      secureIcon: 'assets/images/patient-engagement/secure-email.png'
    },
    SMS: {
      icon: 'assets/images/patient-engagement/insecure-sms.png',
      secureIcon: 'assets/images/patient-engagement/secure-sms.png'
    },
    LOGCALL: {
      icon: 'phone',
      secureIcon: 'phone'
    }
  }
  
  constructor(
    private afs: AngularFirestore,
    public auth: AngularFireAuth,
    private helper: HelperService,
    private httpService: HttpService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.patientId&& (changes.patientId.currentValue !== changes.patientId.previousValue))
      this.getCommunicationMessages();
  }

  // ngOnInit(): void {
  //   // this.patients.push(this.patientDetails);
  // }

    // Pagination
    firstInResponse: any = [];
    lastInResponse: any = [];
    prev_strt_at: any = [];
    pagination_clicked_count = 0;
    disable_next = false;
    disable_prev = false;
    isFakeData = true;
    limit = 5;

    /**
   * This function is used to get the communication messages from the firebase
   *
   * It will fetch the data as per condition and limit
   */
  getCommunicationMessages() {
    this.communicationMessages = [];
    this.isFakeData = true;
    const fireAuthListener = this.auth.authState.subscribe(isAuthenticated => {
      if (isAuthenticated) {
        fireAuthListener.unsubscribe();
        if(this.communicationListener)
          this.communicationListener.unsubscribe();
        this.communicationListener = this.afs.collection("Communication", ref => ref
          .where("subject.reference", "==", `Patient/${this.patientId}`)
          .orderBy('sent', 'desc')
          .limit(this.limit))
          .valueChanges()
          .subscribe((communicationMessages: any) => {
            if (!communicationMessages.length) {
              this.isFakeData = false;
              this.disable_next = true;
              return false;
            }
            this.isInitialAPICall = true;
            this.firstInResponse = communicationMessages[0].sent;
            this.lastInResponse = communicationMessages[communicationMessages.length - 1].sent;
            this.getExtraData(communicationMessages);
            // this.isFakeData = false;

            // Initialize values
            this.prev_strt_at = [];
            this.pagination_clicked_count = 0;
            // this.disable_next = this.communicationMessages.length < this.limit || false;
            this.disable_prev = false;

            // Push first item to use for Previous action
            this.push_prev_startAt(this.firstInResponse);
          }, error => {
            console.log(error)
            this.isFakeData = false;
          });
      }
    })
  }

  /**
   * This function is used to fetch pervious records
   */
  prevPage() {
    if (this.pagination_clicked_count === 1) {
      this.communicationListener.unsubscribe();
      this.getCommunicationMessages();
    } else {
      const count = this.pagination_clicked_count - 1;
      this.isFakeData = true;
      this.disable_prev = true;
      this.communicationListener.unsubscribe();
      this.communicationListener = this.afs.collection("Communication", ref => ref
        .where("subject.reference", "==", `Patient/${this.patientId}`)
        .orderBy('sent', 'desc')
        .startAt(this.get_prev_startAt())
        .endBefore(this.firstInResponse)
        .limit(this.limit))
        .valueChanges()
        .subscribe((communicationMessages: any) => {
          this.firstInResponse = communicationMessages[0].sent;
          this.lastInResponse = communicationMessages[communicationMessages.length - 1].sent;
          this.getExtraData(communicationMessages);
          // this.isFakeData = false;

          // Maintaing page no.
          this.pagination_clicked_count = count;

          // Pop not required value in array
          this.pop_prev_startAt(this.firstInResponse);

          // Enable buttons again
          this.disable_prev = false;
          // this.disable_next = this.communicationMessages.length < this.limit || false;
        }, error => {
          console.log(error)
          this.isFakeData = false;
          this.disable_prev = false;
        });
    }
  }

  /**
   * This function is used to call the next records from the firebase.
   *
   * If firebase returns empty data then it will disable next button
   */
  nextPage() {
    const count = this.pagination_clicked_count + 1;
    this.disable_next = true;
    this.isFakeData = true;
    this.communicationListener.unsubscribe();
    this.communicationListener = this.afs.collection("Communication", ref => ref
      .where("subject.reference", "==", `Patient/${this.patientId}`)
      .orderBy('sent', 'desc')
      .startAfter(this.lastInResponse)
      .limit(this.limit))
      .valueChanges()
      .subscribe((communicationMessages: any) => {
        if (!communicationMessages.length) {
          this.isFakeData = false;
          this.disable_next = true;
          return;
        }
        this.firstInResponse = communicationMessages[0].sent;
        this.lastInResponse = communicationMessages[communicationMessages.length - 1].sent;

        this.getExtraData(communicationMessages);
        // this.isFakeData = false;

        this.pagination_clicked_count = count;

        this.push_prev_startAt(this.firstInResponse);

        // this.disable_next = this.communicationMessages.length < this.limit || false;
      }, error => {
        console.log(error)
        this.isFakeData = false;
        this.disable_next = false;
      });
  }

  // Add document
  push_prev_startAt(prev_first_doc) {
    this.prev_strt_at.push(prev_first_doc);
  }

  // Remove not required document
  pop_prev_startAt(prev_first_doc) {
    this.prev_strt_at.forEach(element => {
      if (prev_first_doc === element) {
        element = null;
      }
    });
  }

  // Return the Doc rem where previous page will startAt
  get_prev_startAt() {
    if (this.prev_strt_at.length > (this.pagination_clicked_count + 1))
      this.prev_strt_at.splice(this.prev_strt_at.length - 2, this.prev_strt_at.length - 1);
    return this.prev_strt_at[this.pagination_clicked_count - 1];
  }

    /**
   * This function is used to bind the practitioner name with the communication message
   * @param messages
   */
  formatMessages(messages) {
    if (this.isPractitionerData && this.isPatientData) {
      messages.map(item => {
        const isSecure = item.category[0].coding[0].code === "SecureMessage";
        const medium = item.medium[0].coding[0].code;
        const icons = this.icons[medium.replace('_', '')];
        const msg = item.payload[0].contentString;
        const templateId = item.dynamicTemplate ? this.helper.extractId(item.dynamicTemplate) : {};
        let sender: any = {};
        let name = '';
        let type;

        if (item.sender.reference.split('/')[0] === 'Practitioner') {
          sender = this.practitioners.find(x => x.id === this.helper.extractId(item.sender));
          type = 'odd';
        } else if (item.sender.reference.split('/')[0] === 'Patient') {
          sender = this.patients.find(x => x.id === this.helper.extractId(item.sender));
          type = 'even';
        }
        name = this.extractName(sender);


        item.display = {
          id: item.id,
          secure: isSecure,
          messageMedium: medium,
          msg,
          name,
          type,
          icon: isSecure ? icons.secureIcon : icons.icon,
          isReadMore: true,
          dynamicTemplate: this.templates.find(x => x.id === templateId)
        }
      })
      this.changeCommunicationMesgStatus(messages);
      this.communicationMessages = messages;
      this.disable_next = this.communicationMessages.length < this.limit || false;
      this.isFakeData = false;

      if(this.isInitialAPICall && this.communicationMessages.length){
        this.latestMessage.emit(this.communicationMessages[0])
        this.isInitialAPICall = false;
      }
    }
  }

  changeCommunicationMesgStatus(messages) {
    const payload = {communicationId: []}
      messages.map(x => {
        if (x.status === 'in-progress' && x.display.type === 'even')
          payload.communicationId.push(x.id)
      })
    if(payload.communicationId.length){
    this.httpService.post('message/status/complete', payload).subscribe()
  }
  }

  extractName(data) {
    if (data && data.fname || data.lname) {
      return `${data.fname} ${data.lname}`;
    } else if (data && data.name && data.name.length && data.name[0].given && data.name[0].given.length) {
      return `${data.name[0].given.join(' ')} ${data.name[0].family}`
    } else if(data){
      return data.name && data.name[0].text;
    }else{
      return '';
    }
  }

  extractSenderAndReceiverIds(data, type) {
    const result = [];
    data.map(item => {
      const key = item.sender.reference.split('/')[0];
      if (key === type) {
        const id = this.helper.extractId(item.sender);
        if (result.findIndex(x => x === id) === -1)
          result.push(this.helper.extractId(item.sender))
      }
    });
    return result;
  }

  getPractitionerData(messages) {
    let practitioners = this.extractSenderAndReceiverIds(messages, 'Practitioner');
    practitioners = practitioners.filter(x => this.practitioners.findIndex(y => y.id === x) === -1);
    if (practitioners.length) {
      const practitionerSubscriber = this.afs.collection("Practitioner", ref => ref
        .where("id", "in", practitioners))
        .valueChanges()
        .subscribe((practitionerData: any) => {
          practitionerSubscriber.unsubscribe();
          this.practitioners = [...this.practitioners, ...practitionerData];
          this.isPractitionerData = true;
          this.formatMessages(messages);
        })
    } else {
      this.isPractitionerData = true;
      this.formatMessages(messages);
    }
  }

  getPatientData(messages) {
    let patients = this.extractSenderAndReceiverIds(messages, 'Patient');
    patients = patients.filter(x => this.patients.findIndex(y => y.id === x) === -1);
    if (patients.length) {
      const patientSubscriber = this.afs.collection("Patient", ref => ref
        .where("id", "in", patients))
        .valueChanges()
        .subscribe((patinetData: any) => {
          patientSubscriber.unsubscribe();
          this.patients = [...this.patients, ...patinetData];
          this.isPatientData = true;
          this.formatMessages(messages);
        })
    } else {
      this.isPatientData = true;
      this.formatMessages(messages);
    }
  }

  getExtraData(messages) {
    this.isPractitionerData = false;
    this.isPatientData = false;
    this.practitioners = [];
    this.patients = [];
    this.getPractitionerData(messages);
    this.getPatientData(messages);
  }

  getDisplayDate(date) {
    return moment(date).fromNow();
  }

  trackByMethod(index: number, el: any): number {
    return el.id;
  }

  onReadMore(data) {
    data.isReadMore = !data.isReadMore;
  }

  ngOnDestroy(): void {
    this.communicationListener.unsubscribe();
  }
}
